import { useHotelSortView } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view/hotel-sort-view.hook";
import { HotelSortViewPropertiesType } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view/hotel-sort-view.types";
import { Button } from "@website/ui/button";
import { MiniPopover } from "@website/ui/mini-popover";
import { Radio } from "@website/ui/radio";
import { FC } from "react";

export const HotelSortView: FC<HotelSortViewPropertiesType> = (properties) => {
  const { buttonProps, popoverProps, radioProps } =
    useHotelSortView(properties);
  return (
    <div className="relative">
      <Button
        {...buttonProps}
        className={`truncate ${buttonProps.className ?? ""}`}
      />
      <MiniPopover
        {...popoverProps}
        popoverClassName={`${popoverProps.className} overflow-hidden`}
      >
        <div className="flex flex-1 flex-col overflow-hidden">
          <div className="flex flex-1 overflow-hidden px-3.5">
            <div>
              {radioProps.list.map((item) => (
                <Radio
                  key={item.label}
                  {...item}
                  checked={radioProps.checkedRadio === item.value}
                  className="my-3 text-sm"
                  color="secondary"
                  name="radiobutton"
                  onChange={radioProps.onChangeRadio}
                />
              ))}
            </div>
          </div>
        </div>
      </MiniPopover>
    </div>
  );
};
